import { useService } from 'react-reservice';

import marketService from './service';

export const useMarket = () => {
  return useService(marketService, (state) => state);
};

export { marketService };
